import { useExpandCollapseAll } from "../../hooks/useExpandCollapseAll";
import { APButtonLink } from "./APButtonLink";

export const ExpandCollapseAllButton = ({
  controller,
}: {
  controller: ReturnType<typeof useExpandCollapseAll>;
}) => {
  return (
    <APButtonLink
      text={controller.isAllExpanded ? "Collapse all" : "Expand all"}
      onClick={controller.toggle}
    />
  );
};
